function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.666687 5.66667C0.666687 4.00981 2.00983 2.66667 3.66669 2.66667H26.3334C27.9902 2.66667 29.3334 4.00981 29.3334 5.66667V23C29.3334 24.6569 27.9902 26 26.3334 26H3.66669C2.00983 26 0.666687 24.6569 0.666687 23V5.66667ZM3.66669 4.66667C3.1144 4.66667 2.66669 5.11438 2.66669 5.66667V23C2.66669 23.5523 3.1144 24 3.66669 24H26.3334C26.8856 24 27.3334 23.5523 27.3334 23V5.66667C27.3334 5.11438 26.8856 4.66667 26.3334 4.66667H3.66669Z",
  fill: "#0A7E85"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33335 11C1.33335 10.4477 1.78107 10 2.33335 10H27.6667C28.219 10 28.6667 10.4477 28.6667 11C28.6667 11.5523 28.219 12 27.6667 12H2.33335C1.78107 12 1.33335 11.5523 1.33335 11Z",
  fill: "#0A7E85"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6667 0C20.219 0 20.6667 0.447715 20.6667 1V6.33333C20.6667 6.88562 20.219 7.33333 19.6667 7.33333C19.1144 7.33333 18.6667 6.88562 18.6667 6.33333V1C18.6667 0.447715 19.1144 0 19.6667 0Z",
  fill: "#0A7E85"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3334 0C10.8856 0 11.3334 0.447715 11.3334 1V6.33333C11.3334 6.88562 10.8856 7.33333 10.3334 7.33333C9.78107 7.33333 9.33335 6.88562 9.33335 6.33333V1C9.33335 0.447715 9.78107 0 10.3334 0Z",
  fill: "#0A7E85"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.e42aef49.svg";
export { ForwardRef as ReactComponent };